import { Frame } from '../atoms/Frame';
import { NumList } from '../atoms/NumList';
import { WizardCtaBar } from '../../../components/atoms/WizardCtaBar';
import { Cross } from '../atoms/Icons';
import { useT } from '../../../i18n/useT';
import { P, S, T } from '../../../styles/tokens';
import type { Checkpoint, CheckpointAttempt, SlotFlowRun } from '../../../api/flow-types';

const ERROR_SOFT_BG = '#FDE8E8';

interface TemplateProps {
  checkpoint: Checkpoint;
  attempt?: CheckpointAttempt;
  flowRun: SlotFlowRun;
  checkpoints: Checkpoint[];
  onCta: () => void;
}

export function RejectScreen({ checkpoint, attempt, onCta }: TemplateProps) {
  const retryLabel = useT('flow.cta.retry');
  // attempt must be non-null when this template renders (rejected state)
  const att = attempt!;
  const counter = useT('flow.attempt.x_of_y', {
    current: att.attempt_number,
    total: checkpoint.max_attempts,
  });

  return (
    <Frame>
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '8px 16px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        {/* Rejection banner — matches prototype TF_Step2Rejected error block */}
        <div
          style={{
            marginTop: 14,
            padding: 14,
            background: ERROR_SOFT_BG,
            border: '1px solid rgba(209,67,67,0.30)',
            borderRadius: 14,
          }}
        >
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 16,
                background: P.error,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                color: '#fff',
              }}
            >
              <Cross size={14} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ font: T.headline, color: P.error, fontWeight: 700 }}>
                Скрин не подошёл
              </div>
              <div
                style={{
                  font: T.footnote,
                  color: S.label,
                  marginTop: 4,
                  lineHeight: 1.5,
                }}
              >
                Проверь требования ниже и попробуй ещё раз.
              </div>
              <div
                style={{
                  font: T.caption,
                  color: S.secondaryLabel,
                  marginTop: 8,
                }}
              >
                {counter}
              </div>
            </div>
          </div>
        </div>

        {/* Reject reasons list */}
        {att.reject_reasons.length > 0 && (
          <div
            style={{
              background: P.card,
              borderRadius: 16,
              padding: '14px 14px',
              border: `1px solid ${P.line}`,
            }}
          >
            <div
              style={{
                font: T.caption,
                fontWeight: 700,
                color: S.label,
                marginBottom: 10,
              }}
            >
              Причины отклонения:
            </div>
            <NumList items={att.reject_reasons} />
          </div>
        )}
      </div>
      <WizardCtaBar label={retryLabel} onClick={onCta} />
    </Frame>
  );
}
